const pathItems = [
    { text: "Completions", number: 1 },
    { text: "Reservoir Engineering", number: 2 },
    { text: "Field Development Planning", number: 3 },
    { text: "Geology", number: 4 },
    { text: "Seismic", number: 5 },
    { text: "Petrophysics", number: 6 },
    { text: "Geothermal", number: 7 },
    { text: "Carbon capture and storage", number: 8 },
]

export default pathItems;